import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";



function GatchamonRulesOld() {
  return (
    <Layout>
      <div className="space-y-6 font-gillsans mb-12">
        <Helmet>
          <title>Règles du Super Gatchamon | Croquette</title>
        </Helmet>
        <p className="text-5xl font-bold text-blue-600 mb-8">
          Règles
        </p>

        <p className="text-3xl font-bold text-blue-600 mb-8">Les termes</p>

        <p><u><b>Inventaire</b></u>: C'est un espace que vous allouez dans votre classeur. Il se pourrait que vous récupériez des items au cours de votre aventure, il faut les stocker quelque part.</p>
        <p><u><b>Deck</b></u>: Il s'agit de la pioche face cachée. Vous ne pourrez jamais regarder les cartes à l'intérieur, seulement les piocher.</p>
        <p><u><b>Pokédex</b></u>: Ce sont les cartes Pokémon dans votre classeur. Lorsque vous piochez un Pokémon pour la première fois, ajoutez-le à votre Pokédex. L'objectif est de capturer les 151 Pokémon de la Première Génération. Un Pokémon placé dans votre Pokédex est voué à rester dans votre Pokédex.</p>
        <p><u><b>Stock</b></u>: Le Stock est un paquet de cartes enveloppées. Il y a 3 types d'enveloppes: les Évolutions, les Quêtes, et les Autres Ajouts. Vous pouvez regarder ce qui est écrit sur les enveloppes à tout moment. Cependant, vous ne pouvez pas utiliser le contenu sans y être invité.</p>
        <p><u><b>Boîte PC</b></u>: C'est un endroit où vous gardez vos Pokémon en double. C'est un endroit séparé de votre Pokédex. Il est conseillé de laisser ces Pokémon sous protège-cartes. De ce fait, une deckbox pourrait faire l'affaire pour stocker vos doublons.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">Commencer à jouer</p>

        <p>Pour commencer, choisissez un Pokémon de départ entre Bulbizarre, Carapuce et Salamèche. Le Pokémon choisi sera le premier de votre Pokédex! Gardez-le, et mélangez les 2 autres à votre deck.</p>
        <p>À chaque tâche effectuée, piochez une carte. Perso je pense piocher environ 5 cartes par jour si je travaille bien, mais chacun fait comme il le sens. C'est aussi une question d'effort, et pas seulement de résultats. Bref faites comme vous le sentez mais ne tirez pas 2 cartes d'un coup, ça ruinera votre expérience.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">Piocher des cartes</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Attraper un nouveau Pokémon</p>

        <p>Lorsque vous piochez un Pokémon que vous n'avez pas dans votre Pokédex, félicitations! Vous venez de capturer une nouvelle espèce! Ajoutez-le à votre Pokédex.</p>
        <p>À chaque fois que vous attrapez un nouveau Pokémon, mélangez l'intégralité de votre Boîte PC à votre deck, à l'exception de Minidraco et de Draco. Assurez-vous que tous les Pokémon mélangés sont sleevés face verso, comme le reste du deck.</p>
        <p>Cependant, il y a une exception à cette règle. Si vous utilisez une Pierre d'Évolution ou un Échange, vous n'aurez pas besoin de mélanger votre Boîte PC à votre deck.</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Évolutions</p>

        <p>Lorsque vous tirez un Pokémon que vous avez déjà, placez-le dans votre Boîte PC. Si le Pokémon peut évoluer, consultez votre Stock. Si vous y trouvez l'enveloppe du Pokémon qui évolue de votre Pokémon, déclenchez l'évolution. Pour ce faire, prenez le contenu de l'enveloppe, et mélangez-le à votre deck. L'évolution de votre Pokémon est à présent attrapable.</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Quêtes</p>

        <p>Certaines enveloppes de votre Stock ont une pastille orange. Ce sont des Quêtes. Il est conseillé de lire les inscriptions de ces enveloppes de temps en temps. À tout moment, si vous avez réussi la quête écrite sur l'enveloppe, vous pouvez mélanger le contenu de l'enveloppe correspondante à votre deck.</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Les Autres Ajouts</p>

        <p>Certaines enveloppes de votre Stock ne sont ni des Évolutions, ni des Quêtes. Il s'agit des Autres Ajouts. Les Autres Ajouts n'ont aucun indice sur comment débloquer le contenu des enveloppes. Faites confiance au Gatchamon.</p>

        <br/>
        <p>Une fois une enveloppe vidée, placez-là hors du jeu. Elle pourra potentiellement resservir pour un futur Gatchamon, qui sait?</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">
          FAQ
        </p>

        <div>
          <p><b>Q</b> - J'ai pioché une énergie, que dois-je faire?</p>
          <p><b>A</b> - Bien joué! Vous avez progressé sur une quête! Vous pouvez lire ce qui est écrit sur l'extérieur des enveloppes à tout moment. Gardez cette énergie dans votre inventaire.</p>
          <br/>
          <p><b>Q</b> - Est-ce que je peux gagner plusieurs Pokémon si j'ai suffisamment de jetons lorsque je tire la carte Game Corner?</p>
          <p><b>A</b> - Non</p>
          <br/>
          <p><b>Q</b> - Je veux mélanger une Safari Ball additionnelle au deck, mais il n'y en a plus en Stock, que faire?</p>
          <p><b>A</b> - Si vous n'avez plus de cartes Safari Ball de disponible, vous ne pouvez pas mélanger de Safari Ball additionnelle au deck.</p>
          <br/>
          <p><b>Q</b> - J'ai mélangé le Minidraco ou Draco qui était dans ma Boîte PC à mon deck! Est-ce que je peux le récupérer?</p>
          <p><b>A</b> - Il est impossible de récupérer des cartes du deck autrement qu'en les piochant. Il va falloir piocher 2 Minidraco/Draco pour le faire évoluer.</p>
        </div>
        <br/>
        <br/>
        <br/>
      </div>
    </Layout>
  );
}

export default GatchamonRulesOld;
